export const MuiSvgIcon = {
  root: { fontSize: "2.4rem" },
  fontSizeSmall: { fontSize: "1.4rem" },
  fontSizeLarge: { fontSize: "3.6rem" },
}
